import { render } from "./users.vue?vue&type=template&id=dbb6bf1c&scoped=true&ts=true"
import script from "./users.vue?vue&type=script&lang=ts"
export * from "./users.vue?vue&type=script&lang=ts"

import "./users.vue?vue&type=style&index=0&id=dbb6bf1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb6bf1c"]])

export default __exports__